import axios from "axios";

// // Create an Axios instance
// const apiClient = axios.create({
//   baseURL: process.env.REACT_APP_API,
// });

// // Add a request interceptor
// apiClient.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers["Authorization"] = token;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error),
// );

// // Add a response interceptor
// apiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (
//       error.response &&
//       (error.response.status === 401 || error.response.status === 403)
//     ) {
//       // Token expired or invalid
//       localStorage.removeItem("token"); // Clear the expired token
//       localStorage.removeItem("user");
//       // Redirect to the login page
//       window.location.href = "/login";
//     }
//     return Promise.reject(error);
//   },
// );

// export default apiClient;

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API,
});

// Request interceptor: attach access token
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers["Authorization"] = token;
  return config;
});

// Response interceptor: handle 401 / refresh token
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Prevent infinite loops
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Call refresh endpoint (refresh token is in HTTP-only cookie)
        const res = await axios.post(
          `${process.env.REACT_APP_API}/auth/refresh`,
          {},
          { withCredentials: true }, // important to send cookie
        );

        const { accessToken } = res.data;
        localStorage.setItem("token", accessToken);

        // Retry original request with new token
        originalRequest.headers["Authorization"] = accessToken;
        return axios(originalRequest);
      } catch (refreshError) {
        // Refresh failed → log out
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default apiClient;
